import {Outlet} from "react-router-dom";

export default function UserRouter() {
    return (
        <div>
            <h1>user routing</h1>
            <Outlet />

        </div>
    )
}